module.exports = __webpack_public_path__ + "fonts/Manrope-700-latin-ext23_1a780b6.woff2";